/**
 * Define el estado de trabajao de un componente
 */
export enum EComponentState {
  /**
   * El componente se encuentra ocioso
   */
  idle = 0,
  /**
   * El componente se encuentra ocupado
   */
  busy = 1,
}
